import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Location } from '@angular/common';
import * as _ from 'lodash';

import { ModalComponent } from '../../modal/modal.component';
import { TrainingProposalsPluginService } from './trainingproposals-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { TrainerPipe } from './trainer.pipe';

@Component({
    selector: 'trainingproposals-edit',
    templateUrl: './trainingproposals-edit.component.html',
    standalone: false
})
export class TrainingProposalsEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public currentItem: any;
  editForm: UntypedFormGroup;
  public processing = false;

  @ViewChild('traineesModal', { static: true })
  trainersModal: ModalComponent;

  public trainingProposals: any;

  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  public trainees: any;
  public productLineIds: string[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: TrainingProposalsPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private trainerPipe: TrainerPipe
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    _.each(model.trainingProposals, (tp: any) => {
      _.remove(tp.Trainees, (t: any) => !t.selected);
    });

    _.each(model.trainingProposals, (tp: any) => {
      tp.Trainees = _.map(tp.Trainees, (t: any) => t.value);
    });

    this.service
      .updateTrainingProposals(
        this.inspectionId,
        this.pluginId,
        model.trainingProposals.filter((tp) => tp.Time || tp.Course || tp.Moment || tp.Trainees.length)
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getTrainers().subscribe((trainees) => {
      this.trainees = _.orderBy(trainees, ['label']);
      this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
        this.plugin = data;
        this.initForm();
        this.cdRef.detectChanges();
      });
    });
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['trainingProposals'];
    control.push(this.initTrainingProposal());
  }

  initForm() {
    this.editForm = this.fb.group({
      trainingProposals: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['trainingProposals'];
    _.forEach(this.plugin.config.TrainingProposals, (el) => {
      control.push(this.initTrainingProposal(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['trainingProposals'];
  }

  initTrainingProposal(el?: any) {
    return this.fb.group({
      Time: [el ? el.Time : null],
      Trainees: [el ? this.processTrainees(el.Trainees) : this.processTrainees(null)],
      Course: [el ? el.Course : null],
      Moment: [el ? el.Moment : null]
    });
  }

  processTrainees(trainees: any): any {
    const clonedTrainees = _.cloneDeep(this.trainees);
    _.each(trainees, (el) => {
      const i = _.findIndex(clonedTrainees, ['value', el]);
      if (i !== -1) {
        clonedTrainees[i].selected = true;
      }
    });
    return clonedTrainees;
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['trainingProposals'];
    control.removeAt(i);
  }

  public openTrainersSelector(i: number): void {
    const control = <UntypedFormArray>this.editForm.controls['trainingProposals'];
    this.currentItem = control.controls[i];
    this.openMultipleSelector(this.trainersModal, this.currentItem.controls['Trainees'].value);
  }

  public selectTrainersMenu(item: any) {}

  private onSelectMenu(item: any, controlName: string) {
    const selectedIndex = this.currentItem.controls[controlName].value === item.selectedIndex ? -1 : item.selectedIndex;
    this.currentItem.controls[controlName].setValue(selectedIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public getSelectedValues(items: any): string {
    const defaultValue = 'Select a trainee';
    let selectedValues = _.filter(items, (item: any) => item.selected);
    selectedValues = _.map(selectedValues, (item: any) => this.trainerPipe.transform(item.value));
    return selectedValues.length > 0 ? selectedValues.join('<br/>') : defaultValue;
  }
}
